import { useEffect, useState } from "react";
import apiClient from "../../../apiClient";
import { ActivityFilters, ActivityRow } from "./activityTypes";

export default function useActivity() {
    const [activity, setActivity] = useState<ActivityRow[]>([]);
    const [filters, setFilters] = useState<ActivityFilters>({});

    const getActivity = async (nextFilters: ActivityFilters = filters) => {
        const res = await apiClient.get(`/inventory-dev/activity`, { params: nextFilters });
        setActivity(res.data);
    };

    useEffect(() => {
        getActivity(filters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters]);

    return { activity, filters, setFilters };
}
